const config = {
  appEnv: process.env.REACT_APP_ENV,
  baseUrl: process.env.REACT_APP_SERVER_URL,
  defaultLanguage: process.env.REACT_APP_LANGUAGE || "es",
};

export default config;
